import React from 'react';

import BaseComponentProperty from "../index";

export default class Spacer extends BaseComponentProperty {
}
